
import { atom } from 'recoil';
import { Dashboard, Workspace, WorkspaceScore, WorkspaceUserMembership } from '../types/files';

const workspacesLoadedState = atom<boolean>({
  key: 'workspaces/workspacesLoaded',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspacesLoaded', newValue]);
    });
  }],
});

const workspacesState = atom<Workspace[]>({
  key: 'workspaces/workspaces',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaces', newValue]);
    });
  }],
});

const workspacesDashboardsState = atom<Record<string, Dashboard[]>>({
  key: 'workspaces/workspacesDashboards',
  default: {},
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspacesDashboards', newValue]);
    });
  }],
});

const workspacesCollectionState = atom<Record<string, Workspace[]>>({
  key: 'workspaces/workspacesCollection',
  default: {},
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspacesCollection', newValue]);
    });
  }],
});

const currentUserWorkspaceUserMembershipsState = atom<WorkspaceUserMembership[]>({
  key: 'workspaces/currentUserWorkspaceUserMemberships',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/currentUserWorkspaceUserMemberships', newValue]);
    });
  }],
});

const workspaceUserMembershipsState = atom<WorkspaceUserMembership[]>({
  key: 'workspaces/workspaceUserMemberships',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaceUserMemberships', newValue]);
    });
  }],
});

const workspaceScoresState = atom<WorkspaceScore[]>({
  key: 'workspaces/workspaceScores',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspaces/workspaceScores', newValue]);
    });
  }],
});

export {
  workspacesLoadedState,
  workspacesState,
  workspacesDashboardsState,
  workspacesCollectionState,
  currentUserWorkspaceUserMembershipsState,
  workspaceUserMembershipsState,
  workspaceScoresState,
};
